export const MAX_PRICE_IMPACT = ["0.1", "0.5", "1"];
